import AES from '@ali/aes-tracker';
/**
 * 根据格式化后的响应体和http status判断请求是否成功
 *
 * @method isSuccess
 * @param {Object} res
 * @param {String} httpStatus
 * @returns {Boolean}
 */

function isSuccess(res, httpStatus) {
  if (httpStatus !== undefined && !(httpStatus >= 200 && httpStatus < 300)) {
    return false;
  }

  if (res.success !== undefined) {
    return res.success === true || res.success === 'true';
  } else if (res.isSuccess !== undefined) {
    return res.isSuccess === true || res.isSuccess === 'true';
  } else if (res.isOk !== undefined) {
    return res.isOk === true || res.isOk === 'true';
  } else if (res.ok !== undefined) {
    return res.ok === true || res.ok === 'true';
  } else if (!isNaN(res.status)) {
    return res.status == 200;
  } else if (!isNaN(res.code)) {
    return res.code == 200;
  }

  return true;
}
/**
 * @method getCode
 * @param {Object} res 
 * @returns 
 */


function getCode(res) {
  return res.code;
}
/**
 * 获取错误信息
 * @method getMessage
 * @param {Object} res 
 * @returns {String}
 */


function getMessage(res) {
  var resmsg = res.msg || res.message || res.errMsg || res.errorMessage || res.errorMsg;

  if (resmsg && resmsg.length > 50) {
    resmsg = resmsg.substring(1, 50);
  }

  return resmsg;
}
/**
 * 获取请求体，对于Blod、BufferSource只记录类型
 * @method getRequestBody
 * @param {Blob|BufferSource|FormData|URLSearchParams|String|Request} body 
 * @param {String} method
 * @returns {String|Promise}
 */


function getRequestBody(body, method) {
  // 1. method为POST、PUT时支持传递body，body包含： Blob, BufferSource (en-US), FormData, URLSearchParams, USVString 对象
  // 2. 二进制相关的Blob、BufferSource以及FormData中的文件类型不支持
  method = method.toUpperCase();

  if (!body || method !== 'POST' && method !== 'PUT') {
    return;
  }

  if (typeof body === 'string') {
    return body;
  } else if (window.FormData && body instanceof FormData) {
    var fields = [];
    body.forEach(function (v, k) {
      fields.push("".concat(k, "=").concat(typeof v === 'string' ? v : Object.prototype.toString.call(v)));
    });
    return fields.join('&');
  } else if (window.URLSearchParams && body instanceof URLSearchParams) {
    return body.toString();
  } else if (window.Request && body instanceof Request) {
    return body.clone().text();
  } else {
    // 对于Blod、BufferSource只记录类型，如：[object Blob]
    return Object.prototype.toString.call(body);
  }
}
/**
 * 相应处理
 * @method parseResponse
 * @param {String|Object} str 
 * @param {String} httpStatus 
 * @param {Object} reqInfo 
 * @returns 
 */


function parseResponse(str, httpStatus, reqInfo
/** 请求信息，包含type=xhr/fetch, params, url */
) {
  var res = str;

  if (typeof res === 'string') {
    try {
      res = JSON.parse(str);
    } catch (e) {}
  }

  var result;

  if (Object.prototype.toString.call(res) === '[object Object]') {
    result = {
      msg: getMessage(res),
      code: getCode(res),
      success: isSuccess(res, httpStatus)
    };
  } else {
    result = {
      success: httpStatus === undefined || httpStatus >= 200 && httpStatus < 300
    };
  }

  var config = AES.getConfig('plugin_api') || {};

  if (typeof config.parseResponse === 'function') {
    var customize;

    try {
      customize = config.parseResponse(res, httpStatus, reqInfo) || {};
    } catch (e) {
      customize = {};
    }

    customize.msg !== undefined && (result.msg = customize.msg);
    customize.code !== undefined && (result.code = customize.code);
    customize.success !== undefined && (result.success = customize.success);
  }

  return result;
}
/**
 * 判断是否是被忽略的资源
 * @method isIgnoreApi
 * @param {String} original_url 
 * @returns 
 */


function isIgnoreApi(original_url) {
  return !original_url || // 跳过MTOP，MTOP走hookMtop.js
  original_url.indexOf('api=') !== -1 && original_url.indexOf('v=') !== -1 && original_url.indexOf('jsv=') !== -1 || // 跳过A+域名
  original_url.indexOf('.mmstat.com=') !== -1 || // 跳过assets
  original_url.match(/\.(js|css|png|jpg|gif|jpeg|webp|ico|svg)(\?.*)?$/);
}

export { getRequestBody, parseResponse, isSuccess, getMessage, isIgnoreApi };


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-api@1.1.12@@ali/aes-tracker-plugin-api/es/libs/parseResponse.js
// module id = null
// module chunks = 